import React from 'react'
import DeviceSelector from './DeviceSelector'
import MeasurementSelector from './MeasurementSelector'
import ViewToggles from './ViewToggles'

const ChartControls = React.memo(({
  selectedDevices,
  handleDevicesChange,
  availableDevices,
  deviceMeasurementsMap,
  devicesLoading,
  devicesError,
  selectedMeasurements,
  handleMeasurementsChange,
  availableMeasurements,
  measurementsLoading,
  handleClearSelections,
  timeRange,
  onTimeRangeChange,
  chartDataLoading,
  configLoading,
  error,
  isExternallySetCustom,
  onExternalCustomProcessed,
  onExportData,
}) => {
  const viewTogglesDisabled = chartDataLoading || devicesLoading || measurementsLoading || configLoading
  const resetSelectionsDisabled = !(selectedDevices.length > 0 || selectedMeasurements.length > 0 || (timeRange && timeRange.duration !== 'allTime'))
  const measurementSelectorError = error && (error.includes('measurement') || error.includes('Measurement')) ? error : null

  let selectionMessage = null
  if (!devicesLoading && !selectedDevices.length && !error) {
    selectionMessage = 'Please select at least one device.'
  } else if (!chartDataLoading && !measurementsLoading && selectedDevices.length > 0 && !selectedMeasurements.length && availableMeasurements.length > 0 && !error) {
    selectionMessage = 'Please select at least one measurement.'
  }

  return (
    <>
      <ViewToggles
        timeRange={timeRange}
        onTimeRangeChange={onTimeRangeChange}
        disabled={viewTogglesDisabled}
        isExternallySetCustom={isExternallySetCustom}
        onExternalCustomProcessed={onExternalCustomProcessed}
        onExportData={onExportData}
      />

      {selectionMessage && (
        <div className="alert alert-info mt-3 mb-3">
          <i className="bi bi-info-circle me-2"></i>
          {selectionMessage}
        </div>
      )}

      <div className="row mb-3">
        <div className="col-md-6 mb-3 mb-md-0">
          <DeviceSelector
            selectedDevices={selectedDevices}
            onChange={handleDevicesChange}
            availableDevices={availableDevices}
            deviceMeasurementsMap={deviceMeasurementsMap}
            loading={devicesLoading}
            error={devicesError}
          />
        </div>
        <div className="col-md-6">
          <MeasurementSelector
            availableMeasurements={availableMeasurements}
            selectedMeasurements={selectedMeasurements}
            onChange={handleMeasurementsChange}
            loading={measurementsLoading}
            error={measurementSelectorError}
          />
        </div>
      </div>

      {/* Reset Selections Button */}
      <div className="row mt-n2 mb-4">
        <div className="col-12 text-end">
          <button
            className="btn btn-outline-secondary btn-sm"
            onClick={handleClearSelections}
            disabled={resetSelectionsDisabled}
          >
            <i className="bi bi-arrow-counterclockwise me-1"></i> Reset Selections
          </button>
        </div>
      </div>

      {/* Informational messages for measurement selection */}
      {!chartDataLoading && !measurementsLoading && selectedDevices.length > 0 && !selectedMeasurements.length && availableMeasurements.length === 0 && !error && (
        <div className="alert alert-info mt-4">
          <i className="bi bi-info-circle me-2"></i>
          No measurements available for the selected device. Please select different device or check configuration.
        </div>
      )}
    </>
  )
})

ChartControls.displayName = 'ChartControls'

export default ChartControls
